import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export function useIsSuperAdmin() {
  const { user } = useAuth();

  const { data: isSuperAdmin = false, isLoading } = useQuery({
    queryKey: ["is-super-admin", user?.id],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("is_super_admin", {
        _user_id: user!.id,
      });
      if (error) throw error;
      return !!data;
    },
    enabled: !!user?.id,
    staleTime: 10 * 60 * 1000,
  });

  return { isSuperAdmin, isLoading };
}
